import { IconPlus } from '@tabler/icons-react';
import { useTranslation } from 'react-i18next';

import { Button, Typography } from '@cfa/react-components';

interface AddResourceToSubtitleButtonProps {
  onAdminAddResourceToSubtitle: () => void;
}

const AddResourceToSubtitleButton: React.FC<
  AddResourceToSubtitleButtonProps
> = ({ onAdminAddResourceToSubtitle }) => {
  const { t } = useTranslation();
  return (
    <Button
      className="ml-4! w-fit!"
      color="secondary"
      onClick={onAdminAddResourceToSubtitle}
      variant="text"
    >
      <IconPlus className="mr-2!" />
      <Typography
        color="secondary"
        data-testid="AddResourceToNewSection"
        variant="body1"
      >
        {t('Admin.addResource')}
      </Typography>
    </Button>
  );
};

export default AddResourceToSubtitleButton;
